import { AgDialog } from '@australiangreens/ag-internal-components';
import { DialogContentText } from '@mui/material';

type TemplateLoadErrorDialogProps = {
  isOpen: boolean;
  message: string;
  onClose: () => void;
};

export default function TemplateLoadErrorDialog({
  isOpen,
  message,
  onClose,
}: TemplateLoadErrorDialogProps) {
  return (
    <AgDialog
      dialogTitle="Template cannot be loaded"
      isOpen={isOpen}
      onClose={onClose}
      primaryButton={{
        text: 'OK',
        onClick: async () => {
          onClose();
        },
      }}
      secondaryButton={{ text: '', disabled: true }}
    >
      <DialogContentText>{message}</DialogContentText>
    </AgDialog>
  );
}
